const colors = [
    "#800",
    "#080",
    "#008",
    "#880",
    "#808",
    "#088",

    "#0a6",
    "#06a",
    "#a60",
    "#a06",
    "#6a0",
    "#60a",

    "#2c8",
    "#28c",
    "#c82",
    "#c28",
    "#8c2",
    "#82c",
];

const Colorizer = {
    ForNumber(number) {
        const color = colors[number % colors.length];

        return color;
    }
};

module.exports = Colorizer;


// WEBPACK FOOTER //
// ./src/Colorizer.js